import React from 'react';
import AdminCrudTable from './AdminCrudTable';

const AdminCourses = () => (
  <AdminCrudTable
    entityName="courses"
    idField="course_id"
    columns={[
      { key: 'image', label: 'Image', type: 'image' },
      { key: 'title', label: 'Title' },
      { key: 'category', label: 'Category', type: 'badge' },
      { key: 'level', label: 'Level', type: 'badge' },
      { key: 'instructor', label: 'Instructor' },
      { key: 'duration', label: 'Duration' },
      { key: 'lessons', label: 'Lessons' },
    ]}
    formFields={[
      { key: 'title', label: 'Title', type: 'text', placeholder: 'Course title' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Course description' },
      { key: 'image', label: 'Image URL', type: 'text', placeholder: 'https://...' },
      { key: 'category', label: 'Category', type: 'select', options: ['Spiritual Development', 'Consciousness Uplifting', 'Quantum Enlightenment', 'Energy Healing'] },
      { key: 'level', label: 'Level', type: 'select', options: ['Beginner', 'Intermediate', 'Advanced', 'All Levels'] },
      { key: 'instructor', label: 'Instructor', type: 'text', placeholder: 'Instructor name' },
      { key: 'duration', label: 'Duration', type: 'text', placeholder: 'e.g. 8 Weeks' },
      { key: 'lessons', label: 'Lessons', type: 'text', placeholder: 'e.g. 24 Lessons' },
      { key: 'link', label: 'Enrollment Link (optional)', type: 'text', placeholder: 'https://... (leave empty to disable buttons)' },
    ]}
  />
);

const AdminBooks = () => (
  <AdminCrudTable
    entityName="books"
    idField="book_id"
    columns={[
      { key: 'image', label: 'Cover', type: 'image' },
      { key: 'title', label: 'Title' },
      { key: 'author', label: 'Author' },
      { key: 'description', label: 'Description' },
      { key: 'tags', label: 'Tags', type: 'tags' },
    ]}
    formFields={[
      { key: 'title', label: 'Title', type: 'text', placeholder: 'Book title' },
      { key: 'author', label: 'Author', type: 'text', placeholder: 'Author name' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Book description' },
      { key: 'image', label: 'Cover Image URL', type: 'text', placeholder: 'https://...' },
      { key: 'tags', label: 'Tags', type: 'tags' },
      { key: 'link', label: 'Read More Link', type: 'text', placeholder: 'https://... (opens when Read More is clicked)' },
    ]}
  />
);

const AdminGuides = () => (
  <AdminCrudTable
    entityName="guides"
    idField="guide_id"
    columns={[
      { key: 'image', label: 'Photo', type: 'image' },
      { key: 'name', label: 'Name' },
      { key: 'title', label: 'Title' },
      { key: 'description', label: 'Description' },
    ]}
    formFields={[
      { key: 'name', label: 'Name', type: 'text', placeholder: 'Guide name' },
      { key: 'title', label: 'Title/Role', type: 'text', placeholder: 'e.g. Quantum Consciousness Master' },
      { key: 'image', label: 'Photo URL', type: 'text', placeholder: 'https://...' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Guide description' },
    ]}
  />
);

const AdminApps = () => (
  <AdminCrudTable
    entityName="apps"
    idField="app_id"
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'platform', label: 'Platform', type: 'badge' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status', type: 'badge' },
      { key: 'tags', label: 'Tags', type: 'tags' },
    ]}
    formFields={[
      { key: 'title', label: 'Title', type: 'text', placeholder: 'App name' },
      { key: 'platform', label: 'Platform', type: 'select', options: ['Web', 'Android', 'iOS'] },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'App description' },
      { key: 'tags', label: 'Tags', type: 'tags' },
      { key: 'status', label: 'Status', type: 'select', options: ['available', 'coming_soon'] },
      { key: 'link', label: 'Link', type: 'text', placeholder: 'https://...' },
    ]}
  />
);

const AdminWebsites = () => (
  <AdminCrudTable
    entityName="websites"
    idField="website_id"
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'description', label: 'Description' },
      { key: 'domain', label: 'Domain' },
      { key: 'url', label: 'URL' },
    ]}
    formFields={[
      { key: 'title', label: 'Title', type: 'text', placeholder: 'Website name' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Website description' },
      { key: 'url', label: 'URL', type: 'text', placeholder: 'https://...' },
      { key: 'domain', label: 'Display Domain', type: 'text', placeholder: 'e.g. www.example.com' },
    ]}
  />
);

const AdminChannels = () => (
  <AdminCrudTable
    entityName="channels"
    idField="channel_id"
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'description', label: 'Description' },
      { key: 'url', label: 'URL' },
    ]}
    formFields={[
      { key: 'name', label: 'Channel Name', type: 'text', placeholder: 'اسم القناة' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Short description' },
      { key: 'url', label: 'YouTube URL', type: 'text', placeholder: 'https://youtube.com/@channel' },
    ]}
  />
);

const AdminGallery = () => (
  <AdminCrudTable
    entityName="gallery"
    idField="gallery_id"
    columns={[
      { key: 'image', label: 'Image', type: 'image' },
      { key: 'caption', label: 'Caption' },
      { key: 'link', label: 'Link' },
      { key: 'order', label: 'Order' },
    ]}
    formFields={[
      { key: 'image', label: 'Image URL', type: 'text', placeholder: 'https://... (paste image URL)' },
      { key: 'caption', label: 'Caption (optional)', type: 'text', placeholder: 'Short caption shown on center card' },
      { key: 'link', label: 'Click Link (optional)', type: 'text', placeholder: 'https://... (opens in new tab)' },
      { key: 'order', label: 'Order', type: 'text', placeholder: '0, 1, 2... (lower shows first)' },
    ]}
  />
);

export { AdminCourses, AdminBooks, AdminGuides, AdminApps, AdminWebsites, AdminChannels, AdminGallery };
